import { Component, ElementRef, OnInit, Renderer2, Type, ViewChild } from '@angular/core';
import { ModalConfig, ModalDialogService } from '@shared/services/modal-dialog.service';

@Component({
    selector: 'modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit {

    currentContentComponent: Type<Component>;
    config: ModalConfig;
    @ViewChild('modal') modalRef!: ElementRef;
    private lastFocusedElement: HTMLElement | null = null;

    constructor(
        private readonly modalDialogService: ModalDialogService,
        private readonly renderer: Renderer2
    ) { }

    ngOnInit() {
        this.modalDialogService.modalDialogEventEmitter.subscribe((modalData: { content: Type<Component>, config: ModalConfig }) => {
            this.currentContentComponent = modalData.content;
            if (modalData.content) {
                this.lastFocusedElement = document.activeElement as HTMLElement;
                this.renderer.addClass(document.body, 'modal-is-open');

                this.config = modalData.config;
                setTimeout(() => this.modalRef.nativeElement.focus());

                const main = document.querySelector('main');
                const modal = document.querySelector('modal-dialog');

                if (main && modal) {
                Array.from(main.children).forEach(child => {
                    if (child !== modal) {
                        this.renderer.setAttribute(child, 'inert', 'true');
                    } else {
                        this.renderer.removeAttribute(child, 'inert');
                        }
                    });
                }

            } else {
                const main = document.querySelector('main');
                if (main) {
                Array.from(main.children).forEach(child => {
                    this.renderer.removeAttribute(child, 'inert');
                });
                }

                this.renderer.removeClass(document.body, 'modal-is-open');
                this.lastFocusedElement?.focus();
            }
        });
    }

    accept() {
        this.modalDialogService.closeModalDialog(true)
        this.renderer.removeClass(document.body, 'modal-is-open');
    }

    closeFromOutsideDialog(e: Event) {
        if ((e.target as Element).id == "overlay") {
            this.dismiss();
        }
    }

    dismiss() {
            this.modalDialogService.closeModalDialog();
            this.renderer.removeClass(document.body, 'modal-is-open');
            this.renderer.removeAttribute(document.body, 'inert');
    }

}